<template>
  <div class="scroll-div">
    <div class="page-header-class padding10px">
      <el-button type="text" icon="el-icon-d-arrow-left" @click="close"
        >返回</el-button
      >
    </div>
    <div class="replay-div" v-loading="loading">
      <!-- 邮件详情 -->
      <div class="mail-detail">
        <div class="border-box">
          <div
            v-for="(item, index) in messageContent"
            :key="index"
            :class="item.type == 2 ? 'contentBox' : 'contentBox1'"
          >
            <div class="item">
              <p class="time-css">{{ item.createTime }}</p>
              <div class="textBox" v-html="linkify(item.message)"></div>
            </div>
          </div>
        </div>
        <div class="btnBox">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="Enter发送，Ctrl+Enter换行"
            v-model="content"
            @keydown.enter.native="handKeyCode"
            :disabled="file == '' ? false : true"
          ></el-input>
        </div>
        <div
          class="table-header"
          style="
            justify-content: end;
            align-items: self-start;
            margin-top: 10px;
          "
        >
          <el-button
            :loading="isSend"
            style="margin-right: 10px"
            type="primary"
            @click="send()"
            >发送</el-button
          >
          <el-upload
            class="upload-file"
            ref="uploadFile"
            accept=".jpg,.png,.jpeg"
            action="123456"
            :auto-upload="false"
            :on-change="fileChange"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            multiple
            :limit="1"
          >
            <el-button :disabled="content == '' ? false : true"
              >上传附件</el-button
            >
          </el-upload>
          <p>支持jpg、png、jpeg格式</p>
        </div>
      </div>
      <!-- 订单信息-->
      <div class="ozon-order-box">
        <p>订单编号：{{ infoObj.orderId }}</p>
        <p>平台订单号：{{ infoObj.platformOrderId }}</p>
        <p>收件人：{{ infoObj.customerId }}</p>
        <p>配货状态：{{ infoObj.distributionStatus }}</p>
        <p>物流跟踪号：{{ infoObj.expressNumber }}</p>
        <p>物流方式：{{ infoObj.logisticsMode }}</p>
        <p>下单时间：{{ infoObj.orderDownTime }}</p>
        <p>最早预计送达时间：{{ infoObj.earliestArrivalTime }}</p>
        <p>最晚预计送达时间：{{ infoObj.latestArrivalTime }}</p>
        <p>订单总价：{{ infoObj.orderAmount }}</p>
        <p>账号：{{ infoObj.accountNumber }}</p>
        <p>订单状态：{{ infoObj.orderStatus }}</p>
        <p>币种：{{ infoObj.orderCurrency }}</p>
        <!-- <el-empty description="暂无订单信息"></el-empty> -->
        <h3 style="margin-top: 20px">订单明细</h3>
        <commonTable
          ref="multipleTable"
          :isExpand="false"
          :isPage="false"
          :tableData="infoObj.detailList"
          :tableLabel="tableLabel"
        ></commonTable>
      </div>
    </div>
    <imgView
      :dialog.sync="isShowImg"
      :imgList="imgView_msg.list"
      :imgIndex="imgView_msg.index"
      :ImgUrl="ImgUrl"
    >
    </imgView>
    <look v-if="lookShow" :scope="lookObj" @isShowEdit="closeApply"></look>
    <el-button
      v-if="isBottom"
      @click="toBottom"
      size="medium"
      circle
      class="to-bottom"
      icon="el-icon-caret-bottom"
    ></el-button>
  </div>
</template>
<script>
/**
 * Ozon 邮件详情/回复页组件
 * 功能：聊天式消息流展示（左右气泡、URL 自动转链接）、文本框 Enter 发送 Ctrl+Enter 换行、
 *       单张图片附件上传发送、右侧订单信息与订单明细、SKU 查看产品资料
 */
import {
  setRead,
  ozonShowDetail,
  ozonGetOrderInfo,
  ozonSendMessage,
  ozonSendFile,
} from "@/api/user";
import imgView from "./imgView";
import look from "./look";
import serverPath from "@/config/config.js";
export default {
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { imgView, look },
  data() {
    return {
      platform: 1, // 亚马逊平台id
      // 详情加载状态
      loading: true,
      checked: "",
      test: [],
      // 回复文本内容
      content: "",
      isShow: true,
      isOrderInfo: true,
      // 是否显示返回底部按钮
      isBottom: false,
      qaObj: {},
      tableLabel: [
        {
          label: "SKU",
          param: "sku",
          align: "center",
          show: true,
        },
        {
          label: "SKU名称",
          param: "skuName",
          align: "center",
          show: true,
        },
        {
          label: "订单数量",
          param: "qty",
          align: "center",
          show: true,
        },
      ],
      tableData: [],
      // 是否打开图片查看弹窗
      isShowImg: false,
      imgView_msg: {
        show: false, //是否打开图片查看
        index: 0, //图片查看下标
        list: [], //图片列表
      },
      // 订单信息数据
      infoObj: {},
      // 会话 id
      chatId: "",
      // 买家用户 id
      userId: "",
      messageContent: [], // 消息列表
      // 是否打开产品资料弹窗
      lookShow: false,
      // 产品资料弹窗参数（sku）
      lookObj: {},
      // 发送中的加载状态
      isSend: false,
      // 待上传的附件文件
      file: "",
    };
  },
  computed: {
    dropList() {
      return this.$store.getters.dropList;
    },
    ImgUrl() {
      // 图片地址
      const env = serverPath.env;
      if (env === "test" || env === "dev" || env === "localhost") {
        return serverPath.serverPath.server + "/";
      } else {
        return "http://images.delaman168.com/crm/";
      }
    },
  },
  mounted() {
    // 页面挂载时加载会话详情与订单信息
    this.getDetail();
  },
  created() {
    // this.$removeStorage("AmazonTitle");
    // 监听页面滚动，用于显示返回底部按钮
    window.addEventListener("scroll", this.watchScroll, true);
  },
  methods: {
    getDetail() {
      // 点进详情标记为已读
      // this.setRed();
      let obj = {
        id: this.scope.id,
        type: 1,
      };
      // 调详情接口
      ozonShowDetail(obj).then((res) => {
        if (res.code === 200) {
          this.loading = false;
          this.chatId = res.data.chatId;
          this.userId = res.data.userId;
          this.messageContent = res.data.messageDetailList;
          this.init();
        }
      });
    },
    /** 按买家用户 id 查询订单信息（无历史信息时提示） */
    init() {
      if (this.userId) {
        ozonGetOrderInfo({ customerId: this.userId }).then((res) => {
          if (res.code === 200) {
            this.infoObj = res.data;
          }
        });
      }else{
        return this.$message.error("此对话无历史信息！");
      }
    },
    handKeyCode(e) {
      // ctrl+enter
      if (e.keyCode === 13 && e.ctrlKey) {
        this.content += "\n";
      } else {
        this.send();
        if (e != undefined) {
          // 阻止浏览器默认的回车触发方法
          e.preventDefault();
        }
      }
    },
    /** 监听滚动位置，超过阈值时显示返回底部按钮 */
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.querySelector(".scroll").scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 20) {
        this.isBottom = true;
      } else {
        this.isBottom = false;
      }
    },
    /** 滚动到页面底部 */
    toBottom() {
      let top = document.querySelector(".scroll").scrollHeight;
      document.querySelector(".scroll").scrollTop = top;
    },
    /** 选择附件文件时暂存 */
    fileChange(file) {
      this.file = file.raw;
    },
    // 文件超出个数限制时的钩子
    handleExceed() {
      this.$message.error(`附件单次最多只能上传1个`);
    },
    /** 移除已选附件时清空暂存文件 */
    handleRemove() {
      this.file = "";
    },
    /** 设置邮件为已读（当前调用已被注释，未启用） */
    setRed() {
      let param = {
        id: this.scope.id,
      };
      setRead(param).then((result) => {
        if (result.code == 200) {
          this.$emit("getList");
        }
      });
    },

    // 关闭弹窗
    closeApply() {
      this.lookShow = false;
    },

    /** 关闭页面并通知父组件刷新列表 */
    close() {
      this.$emit("isShowEdit");
      this.$emit("getList");
    },

    // 回复邮件
    send() {
      if (this.content == "" && this.file == "") {
        return this.$message.error("输入内容或文件为空！");
      }
      if (this.content) {
        let param = {
          chatId: this.chatId,
          text: this.content,
          account: this.scope.account,
        };
        this.isSend = true;
        ozonSendMessage(param)
          .then((result) => {
            this.isSend = false;
            if (result.code == 200) {
              this.$message.success("发送成功");
              this.content = "";
              // this.close();
              this.getDetail();
            }
          })
          .catch(() => {
            this.isSend = false;
          });
      }
      if (this.file) {
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("chatId", this.chatId);
        formData.append("account", this.scope.account);
        this.isSend = true;
        ozonSendFile(formData)
          .then((result) => {
            this.isSend = false;
            if (result.code == 200) {
              this.$message.success("发送成功");
              this.file = "";
              // this.close();
              this.getDetail();
            }
          })
          .catch(() => {
            this.isSend = false;
          });
      }
    },
    // 查看大图
    seeImg(index) {
      this.imgView_msg.index = index;
      this.isShowImg = true;
    },
    /** 将消息文本中的 URL 自动转换为可点击链接（图片转 img 标签逻辑已注释） */
    linkify(value) {
      let text = value;
      // if (
      //   text.indexOf(".jpg") >= 0 ||
      //   text.indexOf(".jpeg") >= 0 ||
      //   text.indexOf(".png") >= 0
      // ) {
      //   const str = text.split("![](")[1].split(")");
      //   // 替换图片地址为HTML图片标签
      //   text = str[0].replace(
      //     /http[s]?:\/\/[^\s]+\.(jpg|jpeg|png|gif)/g,
      //     '<img src="$&" alt=""/>'
      //   );
      // } else {
      // 链接
      text = text.replace(
        /http[s]?:\/\/[^\s]+/g,
        '<a href="$&" target="_blank">$&</a>'
      );
      // }
      return text;
    },
  },
};
</script>
<style lang="scss">
.padding10px {
  padding: 10px !important;
}
.replay-div {
  display: flex;
  align-items: flex-start;
  .mail-detail {
    width: 70%;
    margin-right: 30px;
    .border-box {
      border: 1px solid #ebeef5;
      border-radius: 10px;
      padding: 10px;
      // width: 100%;
      margin-bottom: 20px;
      position: relative;
    }
    .contentBox {
      display: flex;
      align-items: flex-start;
    }
    .contentBox1 {
      display: flex;
      justify-content: flex-end;
    }
    .item {
      max-width: 70%;
      padding: 15px;
      background-color: #f5f7fa;
      border-radius: 15px;
      margin-bottom: 40px;
    }
    .time-css {
      color: #7f7f7f;
      font-size: 11px;
      margin-bottom: 15px;
    }
    img {
      width: 100px;
      height: 100px;
    }
  }
  .ozon-order-box {
    width: 25%;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    padding: 10px;
    p {
      font-size: 13px;
      color: #333333;
      line-height: 35px;
    }
  }
}
/*.border-box a {
  pointer-events: none !important;
}*/
</style>